// extracted by mini-css-extract-plugin
export default {"input":"BaseLoginInput_input__4eXdx"};